import { Card, CardContent, CardHeader } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import Chart from 'react-apexcharts';
import { TotalSales } from '../../../store/dashboardReport/api/interface';
import { customFormatDate } from '../../../utils/customFormatDate';

const useChartOptions = (categories: string[], theme: any) => {
  return {
    chart: {
      background: 'transparent',
      toolbar: {
        show: false,
      },
    },
    colors: [
      theme.palette.primary.main,
      alpha(theme.palette.primary.main, 0.25),
    ],
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
      type: 'solid',
    },
    grid: {
      borderColor: theme.palette.divider,
      strokeDashArray: 2,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        columnWidth: '40px',
      },
    },
    stroke: {
      colors: ['transparent'],
      show: true,
      width: 2,
    },
    theme: {
      mode: theme.palette.mode,
    },
    xaxis: {
      axisBorder: {
        color: theme.palette.divider,
        show: true,
      },
      axisTicks: {
        color: theme.palette.divider,
        show: true,
      },
      categories: categories,
      labels: {
        offsetY: 5,
        style: {
          colors: theme.palette.text.secondary,
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (value: any) => (value > 0 ? `${value}` : `${value}`),
        offsetX: -10,
        style: {
          colors: theme.palette.text.secondary,
        },
      },
    },
  };
};

export const OverviewSales = (props: any) => {
  const theme = useTheme();
  const { data, sx } = props;

  const categories = data?.map((item: TotalSales) =>
    customFormatDate(item.date)
  );

  const series = [
    {
      name: 'Sales',
      data: data?.map((item: TotalSales) =>
        parseFloat(Number(item.sale ?? 0).toFixed(2))
      ),
    },
  ];

  const chartOptions = useChartOptions(categories, theme);

  return (
    <Card sx={sx}>
      <CardHeader title='Total Sales' />
      <CardContent>
        {series && (
          <Chart
            height={350}
            options={chartOptions}
            series={series}
            type='bar'
            width='100%'
          />
        )}
      </CardContent>
    </Card>
  );
};
